import React from 'react';

const BuyButton = ({ label, articleNumber, href, cssClass, onClick, loading, isShowMore = false }) => {
    return (
        articleNumber && isShowMore == false ? 
            <button className={`${cssClass} ${loading ? 'button--loading button--disabled' : ''}`} 
                disabled={loading} 
                onClick={() => onClick(articleNumber)}>
                {
                    loading 
                        ? <>
                            <BuyButtonLoader /> 
                            <span>{label}</span>
                        </>
                        : <span>{label}</span>
                }
            </button> :
            <a className={cssClass} href={href}>
                {label}
            </a>
    )
}

const BuyButtonLoader = () => <div className="button-loader"><div></div><div></div><div></div><div></div></div>

export default BuyButton;